export enum LocalStorageKey {
    USER_SIGNUP = "UserSignup",
    ORGANIZATION = "Organization",
    NOTIFICATION = "Notification",
    TOKEN = "Token",
}

export class LocalStorageService {
    clear(): void {
        localStorage.clear();
    }

    setItem(key: LocalStorageKey, item: any): void {
        localStorage.setItem(key, JSON.stringify(item));
    }

    getItem(key: LocalStorageKey): any {
        const data = localStorage.getItem(key);
        if (!data) {
            return null;
        }
        return JSON.parse(data);
    }
}
